var map = {
	"./bgp01.jpg": "5573",
	"./bgp02.jpg": "59d5",
	"./bgp03.jpg": "3cf0",
	"./bgp04.jpg": "9fc6",
	"./bgp05.jpg": "16b2",
	"./bgp06.jpg": "c530",
	"./bgp07.jpg": "3f3f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d26f";